// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__2HpxA","auth":"Layout_auth__G+KRC"};